module.exports = "https://cdn.littlereply.com/tt/resource/image_more_item_order@3x.c41729c0d6e6fb512c96465e18005745.png";